<template>
    <div>
        <b-row>
            <b-col sm="12" md="6">
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('date')">
                                {{ formData.application_date }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('gender')">
                                {{ getLocaleText(formData, 'gender') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('student_number')">
                                {{ formData.student_number }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('name_surname')">
                                {{ formData.student_name+' '+formData.student_surname }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('nationality')">
                                {{ getLocaleText(formData, 'nationality') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('birthdate')">
                                {{ formData.birthdate }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('education_info').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('faculty')">
                                {{ getLocaleText(formData, 'faculty') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('department')">
                                {{ getLocaleText(formData, 'program_name') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('class')">
                                {{ getLocaleText(formData, 'class_name') }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('contact_information').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('city')">
                                {{ formData.contact_city }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('district')">
                                {{ formData.contact_district }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="12">
                            <b-form-group :label="$t('address')">
                                {{ formData.address }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('telephone')">
                                {{ formData.phone }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('email')">
                                {{ formData.email }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_place_of_residence')">
                                {{ setLivingPlace(formData.living_place) }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="formData.living_place == 'dormitory' ? $t('pcgc_dormitory_name') : $t('other')">
                                {{ formData.living_place_detail }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('emergency_status_info').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('name_surname')">
                                {{ formData.emergency_contact_name }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('telephone')">
                                {{ formData.emergency_contact_phone }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('degree_of_proximity')">
                                {{ formData.emergency_contact_relationship }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('family_info').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('mother')"></b-form-group>
                            <b-form-group :label="$t('pcgc_is_alive')">
                                {{ formData.mother_is_alive ? $t('yes') : $t('no') }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_age')">
                                {{ formData.mother_age }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_education_level')">
                                {{ formData.mother_education }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_job')">
                                {{ formData.mother_profession }}
                            </b-form-group>
                            <b-form-group :label="$t('telephone')">
                                {{ formData.mother_phone }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('father')"></b-form-group>
                            <b-form-group :label="$t('pcgc_is_alive')">
                                {{ formData.father_is_alive ? $t('yes') : $t('no') }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_age')">
                                {{ formData.father_age }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_education_level')">
                                {{ formData.father_education }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_job')">
                                {{ formData.father_profession }}
                            </b-form-group>
                            <b-form-group :label="$t('telephone')">
                                {{ formData.father_phone }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_mother_and_father')">
                                {{ setParentsRelationshiStatus(formData.parents_relationship_status) }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('other')">
                                {{ formData.parents_relationship_status_detail }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('pcgc_siblings').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_have')">
                                {{ formData.has_siblings ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_how_many_girl')">
                                {{ formData.female_sibling_count }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_ages')">
                                {{ formData.female_sibling_ages }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_how_many_boy')">
                                {{ formData.male_sibling_count }}
                            </b-form-group>
                            <b-form-group :label="$t('pcgc_ages')">
                                {{ formData.male_sibling_ages }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" md="12" class="pl-0 mt-4"><h6>{{ $t('pcgc_step_1').toUpper() }}</h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_share_with_family')">
                                {{ formData.share_with_family ? $t('pcgc_approve') : $t('pcgc_decline') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_share_with_university')">
                                {{ formData.share_with_university ? $t('pcgc_approve') : $t('pcgc_decline') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group :label="$t('pcgc_share_with_academic')">
                                {{ formData.share_with_instructor ? $t('pcgc_approve') : $t('pcgc_decline') }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col v-if="mode == 'edit'" sm="12" md="12" class="rounded border p-2 mt-4">
                    <b-row>
                        <b-col sm="12" md="6">
                            <ValidationProvider name="appointment_date" rules="" v-slot="{ errors }">
                                <b-form-group :label="$t('pcgc_appointment_date')">
                                    <select-date
                                        v-model="formData.appointment_date"
                                        :validation-error="errors[0]"
                                        :is-time="true"/>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="12" md="6" class="p-2 d-flex justify-content-end">
                            <b-button variant="primary" class="mt-4 mr-4" @click="updateAppointment">{{ $t('approve') }}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-col>
            <b-col sm="12" md="6">
                <b-col sm="12" md="12" class="pl-0" :class="blurContent ? 'blur-area' : ''"><h6>
                    {{ $t('application_reason').toUpper() }} <a href="#" @click="blurContent = !blurContent"><i class="ri-eye-fill"></i></a>
                </h6></b-col>
                <b-col sm="12" md="12" class="rounded border p-2">
                    <b-row>
                        <b-col sm="12" md="12"><h6>{{ $t('pcgc_application_reason').toUpper() }}</h6></b-col>
                        <b-col sm="12" md="12">
                            <b-form-group label="">
                                {{ formData.application_reason }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="12"><h6>{{ $t('pcgc_before').toUpper() }}</h6></b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_before_meet_pcgc')">
                                {{ formData.has_previous_pdrm_interview ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_which_dates')">
                                {{ formData.previous_pdrm_interview_dates }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_who_experts')">
                                {{ formData.previous_pdrm_interview_specialists }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_external_psychologist')">
                                {{ formData.has_external_psychological_support ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_suicide_attempt')">
                                {{ formData.has_suicide_attempt ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="12"><h6>{{ $t('pcgc_right_now').toUpper() }}</h6></b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_suicide_attempt_opinion_now')">
                                {{ formData.has_self_harm_or_suicidal_thoughts ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_psychology_treat')">
                                {{ formData.has_psychological_treatment ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_psychology_treat_expert_name')">
                                {{ formData.treatment_specialist_name }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_psychology_treat_expert_phone')">
                                {{ formData.treatment_specialist_phone }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_physical_problem_now')">
                                {{ formData.has_diagnosed_physical_condition ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_please_explanation')">
                                {{ formData.diagnosed_physical_condition_detail }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_have_use_medicine')">
                                {{ formData.has_medication ? $t('yes') : $t('no') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_which_medicines')">
                                {{ formData.medication_names }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_why_how_log_use_medicines')">
                                {{ formData.medication_usage_reason_duration }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('pcgc_how_start_use_medicine')">
                                {{ setMedicationStart(formData.medication_start_method) }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('please_specify')">
                                {{ formData.medication_start_method_detail }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-col>
        </b-row>
    </div>
</template>
<script>

//Components
import {ValidationObserver, ValidationProvider} from "vee-validate"
import SelectDate from "@/components/interactive-fields/SelectDate"

//Services
import PcgcService from "@/services/PcgcService";




export default {
    props: {
        id: {
            type: Number,
        },
        mode: {
            type: String,
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        SelectDate
    },

    data() {
        return {
            formData: {},
            blurContent: true
        }
    },

    created() {
        this.getData()
    },

    methods: {
        getData() {
            PcgcService.getPcgcApplication(this.id).then(response => {
                this.formData = response.data.data
                this.formData.appointment_date = this.formData.appointment_date+' '+this.formData.appointment_time.substring(0,5)
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        updateAppointment(){
            this.$swal.fire({
                title: this.$t('confirmation'),
                text: this.$t('pcgc_change_time_info'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    let formData = {
                        appointment_date: this.formData.appointment_date.substring(0,10),
                        appointment_time: this.formData.appointment_time.substring(0,5),
                    }

                    PcgcService.approveAppointment(formData,this.id).then(response => {
                        this.$toast.success(this.$t("api."+response.data.message))
                        this.$emit('updateTable')
                    }).catch(e => {
                        this.showErrors(e, null)
                    })
                }
            })
        },

        setLivingPlace(data){
            switch (data) {
                case 'dormitory': return this.$t("pcgc_at_dormitory")
                case 'with_family': return this.$t("pcgc_with_family")
                case 'at_home_alone': return this.$t("pcgc_at_home_alone")
                case 'with_relatives': return this.$t("pcgc_with_relatives")
                case 'at_home_with_friends': return this.$t("pcgc_at_home_with_friends")
                case 'other': return this.$t("other")
            }
        },

        setParentsRelationshiStatus(data){
            switch (data) {
                case 'married': return this.$t("married")
                case 'divorced': return this.$t("pcgc_divorced")
                case 'live_together': return this.$t("pcgc_live_together")
                case 'married_to_others': return this.$t("pcgc_married_to_others")
                case 'other': return this.$t("other")
            }
        },

        setMedicationStart(data){
            switch (data) {
                case 'doctors_advice': return this.$t("pcgc_doctors_advice")
                case 'myself': return this.$t("pcgc_myself")
                case 'other': return this.$t("other")
            }
        }
    },
};
</script>

<style scoped>
    .blur-area {
        content: '';
        width: 97%;
        height: 100%;
        background: rgba(0, 0, 0, .2);
        position: absolute;
        z-index: 99;
        backdrop-filter: blur(4px);
        border: 1px solid rgba(0, 0, 0, .2);
        border-radius: 4px;
    }
</style>

